import React, { Component } from 'react';
import * as Styles from './Styles';
import { ConnectedProps, connect } from 'react-redux';
import { AppState } from '../../core/Store';
import SvgCancel from '../../others/svg_dist/Cancel';
import * as FormManager from '../../reducers/ui/form';
import * as DictionariesRisksSelectors from '../../reducers/data/dictionaries/risks/selectors';
import * as MobileSummaryModalManager from '../../reducers/ui/mobileSummaryModal';

type State = {};

class MobileSummaryModalComponent extends Component<PropsFromRedux, State> {
	state = {};

	MULTIPLY_FACTOR = 1.5;

	calcTotalPrice = () => {
		const allSelectedRisks = this.props.allRisksDict.filter((el) =>
			this.props.selectedRisksIds.includes(el.riskId)
		);
		const mappedSelectedRisks = allSelectedRisks.map((el) => {
			if (el.riskId <= 6 && this.props.extendedOcCoverageSelected) {
				return {
					...el,
					riskContribution:
						el.riskContribution * this.MULTIPLY_FACTOR,
				};
			}
			return el;
		});

		if (mappedSelectedRisks.length === 0) {
			return '0.00';
		}

		if (mappedSelectedRisks.length === 1) {
			return mappedSelectedRisks[0].riskContribution;
		}

		return mappedSelectedRisks
			.map((el) => el.riskContribution)
			.reduce((prev, current) => (prev += current));
	};

	render() {
		const selectedOCRiskId = this.props.selectedRisksIds.find(
			(id) => id <= 6
		);
		const selectedOCRisk = this.props.allRisksDict.find(
			(el) => el.riskId === selectedOCRiskId
		);

		return (
			<Styles.Wrapper open={this.props.modalOpen}>
				<Styles.ModalContainer>
					<Styles.ModalTitlebar>
						<SvgCancel
							onClick={() =>
								MobileSummaryModalManager.closeModal()
							}
						/>
					</Styles.ModalTitlebar>
					<Styles.HeadingFont>Podsumowanie</Styles.HeadingFont>
					<Styles.ItemsContainer>
						{this.props.selectedRisksIds.map((riskId, idx) => {
							const riskFull = this.props.allRisksDict.find(
								(el) => el.riskId === riskId
							);

							return (
								<React.Fragment key={riskId}>
									<Styles.ItemContainer>
										<Styles.ItemTitleFont>
											{riskFull?.riskName}
										</Styles.ItemTitleFont>
										<Styles.ItemDetailsContainer>
											<p>
												{riskFull?.riskInsuranceAmount
													.toLocaleString()
													.split(',')
													.join(' ')}
											</p>
											<p>
												{riskFull?.riskContribution} zł
											</p>
										</Styles.ItemDetailsContainer>
									</Styles.ItemContainer>
									{this.props.extendedOcCoverageSelected &&
										selectedOCRisk &&
										selectedOCRiskId === riskId && (
											<Styles.ItemContainer>
												<Styles.ItemTitleFont>
													Rozszerzenie OC na cały
													świat
												</Styles.ItemTitleFont>
												<Styles.ItemDetailsContainer>
													<p></p>
													<p>
														{selectedOCRisk.riskContribution /
															2}{' '}
														zł
													</p>
												</Styles.ItemDetailsContainer>
											</Styles.ItemContainer>
										)}
								</React.Fragment>
							);
						})}
					</Styles.ItemsContainer>
					<Styles.SummaryFont>
						{this.calcTotalPrice()} PLN
					</Styles.SummaryFont>
				</Styles.ModalContainer>
			</Styles.Wrapper>
		);
	}
}

interface Own {}

const connector = connect(
	(state: AppState, own: Own) => {
		const risksKop = DictionariesRisksSelectors.getRisksKop(state);
		const risksNnw = DictionariesRisksSelectors.getRisksNnw(state);
		const risksNnwKlauzule =
			DictionariesRisksSelectors.getRisksNnwKlauzule(state);
		const risksOc = DictionariesRisksSelectors.getRisksOc(state);

		return {
			allRisksDict: [
				...risksKop,
				...risksNnw,
				...risksNnwKlauzule,
				...risksOc,
			],
			selectedRisksIds: FormManager.Selectors.getSelectedRisksIds(state),
			modalOpen: MobileSummaryModalManager.Selectors.getModalOpen(state),
			contributionSum: FormManager.Selectors.getContributionSum(state),
			extendedOcCoverageSelected:
				FormManager.Selectors.getExtendedOcCoverageSelected(state),
		};
	},
	(dispatch) => ({})
);

export type PropsFromRedux = ConnectedProps<typeof connector> & Own;

const MobileSummaryModal = connector(MobileSummaryModalComponent);
export default MobileSummaryModal;
